import { ChatButton } from "./ChatButton";
import { useChatVisibility } from "../../hooks/useChatVisibility";
import { useChatUnreadCount } from "../../hooks/useChatUnreadCount";

export type Props = {
  className?: string;
  containerClassName?: string;
  isChatDisabled?: boolean;
};

export function ChatButtonContainer({
  className,
  containerClassName,
  isChatDisabled,
}: Props) {
  const { shouldShowChat, isLoading } = useChatVisibility(isChatDisabled);

  const unreadCount = useChatUnreadCount();

  // Don't render chat button if chat is disabled or still loading
  if (isLoading || !shouldShowChat) {
    return null;
  }

  return (
    <ChatButton
      className={className}
      containerClassName={containerClassName}
      unreadCount={unreadCount}
    />
  );
}

export default ChatButtonContainer;
